import http from './httpRequest.js'

export function getQuickReplyList() {
	return http({
		url: '/api/v1/customer/get_reply_list',
		method: 'get'
	})
}

export function addQuickReply(data) {
	return http({
		url: '/api/v1/customer/add_quick_reply',
		method: 'post',
		data: data
	})
}

export function updateQuickReply(data) {
	return http({
		url: '/api/v1/customer/update_quick_reply',
		method: 'post',
		data: data
	})
}

export function deleteQuickReply(data) {
	return http({
		url: '/api/v1/customer/delete_quick_reply',
		method: 'delete',
		data: data
	})
}
